import { render, staticRenderFns } from "./CarAreaSale.vue?vue&type=template&id=0af6d7a6"
import script from "./CarAreaSale.vue?vue&type=script&lang=js"
export * from "./CarAreaSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports